import React from 'react'
import CareersPage from '../components/CareersPage'
import Header from '../components/Header'
import Footer from '../components/Footer'
function Career() {
  return (
    <div>
        <Header></Header>
        <CareersPage></CareersPage>
        <Footer></Footer>
    </div>
  )
}

export default Career
